import { DEFAULT_PORTS_BRAND } from "../../assets/consts";
import ServerInfo, { PortsType } from "../viewModels/ServerInfo";
import { BuildingFetch } from "./fetchUserBuildings";

const generateServersInfoByBuildings = async (
  building: BuildingFetch[],
  accessToken: string,
  publicAddress: string | null = null,
  ports: PortsType | null = DEFAULT_PORTS_BRAND
): Promise<ServerInfo[]> => {
  const serversInfo: ServerInfo[] = [];
  building?.forEach((building: BuildingFetch) => {
    if (
      building?.cloudPublicAddress &&
      building.cloudServerId &&
      !serversInfo.some((server) => server.serverId == building.cloudServerId)
    ) {
      const generateServerInfoCloudPublicAddress = new ServerInfo(
        building.cloudServerId,
        building.cloudPublicAddress || null,
        null,
        accessToken,
        building.userDisplayName,
        building.userId,
        ports || building.ports
      );
      serversInfo.push(generateServerInfoCloudPublicAddress);
    }
    const generateServerInfoForBuilding = new ServerInfo(
      building.serverId,
      building.publicAddress || null,
      building.localAddress || null,
      accessToken,
      building.userDisplayName,
      building.userId,
      ports || building.ports
    );
    serversInfo.push(generateServerInfoForBuilding);
  });
  return serversInfo;
};

export default generateServersInfoByBuildings;
